module.exports = __webpack_public_path__ + "static/media/trhome.7d6a8c29.png";